import type { SceneBrandkit } from "../types";

export function BrandkitPanel({ brandkit }: { brandkit: SceneBrandkit }) {
  return (
    <div className="space-y-4">
      <div className="space-y-4">
        <div className="space-y-2 text-sm">
          <div className="text-muted-foreground font-medium">Logo</div>
          {brandkit.logo?.signedUrl ? (
            <div className="rounded-md border bg-muted/20 p-4">
              <img
                src={brandkit.logo.signedUrl}
                alt="Brand logo"
                className="max-h-24 max-w-[200px] object-contain"
              />
            </div>
          ) : (
            <div className="text-muted-foreground">No logo attached</div>
          )}
        </div>

        <div className="space-y-2 text-sm">
          <div className="text-muted-foreground font-medium">Typography</div>
          {brandkit.fonts.length === 0 ? (
            <div className="text-muted-foreground">No font loaders attached to this run.</div>
          ) : (
            <div className="space-y-4">
              {brandkit.fonts.map((font) => (
                <div
                  key={`${font.source}-${font.family}-${font.selectedVariant}`}
                  className="space-y-1.5 rounded-md border p-3 bg-muted/10 shrink-0"
                >
                  <div className="flex items-center justify-between">
                    <div className="text-base font-medium" style={{ fontFamily: font.family }}>
                      {font.family}
                    </div>
                    <div className="text-[10px] uppercase tracking-wider text-muted-foreground font-mono">
                      {font.source} · {font.selectedVariant}
                    </div>
                  </div>
                  <div className="text-[15px] leading-snug" style={{ fontFamily: font.family }}>
                    The quick brown fox jumps over the lazy dog.
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
